<template>
  <div
    class="deceased"
    :class="
      expanded
        ? isMobile
          ? 'deceased-mobile'
          : 'deceased-desktop'
        : 'deceased-collapsed'
    "
  >
    <div style="display: flex;">
      <button
        type="button"
        @click="expanded = !expanded"
        class="btn btn-sm btn-deceased"
      >
        <i class="fa fa-bars" aria-hidden="true"></i>
      </button>
      <h3 v-if="expanded" style="margin-left:10px;margin-top">
        {{ $t("deceased.title") }}
      </h3>
    </div>
    <div v-if="expanded" style="margin-top:20px;">
      <div class="form-group">
        <label for="nameInput">{{ $t("deceased.enterName") }}</label>
        <input
          type="text"
          class="form-control"
          id="nameInput"
          v-model="query"
        />
      </div>

      <hr />

      <div class="result">
        <div>
          <vue-good-table
            :columns="columns"
            :rows="rows"
            :line-numbers="true"
            :pagination-options="{
              enabled: true,
              mode: 'records',
              perPage: isMobile ? 5 : 20,
              position: 'top',
              perPageDropdown: [5, 10, 20, 50],
              dropdownAllowAll: true,
              setCurrentPage: 1,
              nextLabel: $t('deceased.next'),
              prevLabel: $t('deceased.prev'),
              rowsPerPageLabel: $t('deceased.rowsPerPage'),
              ofLabel: $t('deceased.of'),
              pageLabel: $t('deceased.page'),
              allLabel: $t('deceased.all')
            }"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'actions'">
                <button class="btn btn-deceased" @click="show(props.row)">
                  {{ $t("deceased.show") }}
                </button>
              </span>
              <span v-if="props.column.field == 'pokojni'">
                {{ props.row[props.column.field] }} <br />
                {{ props.row.datum_rojstva }}
                {{
                  props.row.datum_rojstva && props.row.datum_smrti ? "-" : ""
                }}
                {{ props.row.datum_smrti }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from "@/utils/eventBus";

export default {
  data: () => ({
    query: "",
    expanded: true,
    loading: true,
    timeout: null
  }),
  computed: {
    columns() {
      return this.$store.state.deceased.columns;
    },
    rows() {
      return this.$store.state.deceased.rows;
    },
    isMobile() {
      return this.$store.state.view.isMobile;
    }
  },
  watch: {
    query(val) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.timeout = setTimeout(() => {
        this.$store.dispatch("deceased/get", val);
      }, 500);
    }
  },
  methods: {
    show(item) {
      eventBus.$emit("show", { wkt: item.geom });

      if (this.isMobile) {
        this.expanded = false;
      }
    }
  }
};
</script>

<style scoped lang="stylus">
.deceased {
  width: 700px;
  padding: 20px;
  text-align: left;
  overflow-y: scroll;
  background-color: rgba(200,200,200,0.8);
}
.result {
  max-height: 100%;
  owerflov-y: auto; /*scroll*/
}
.btn-deceased {
  background-color: #09665c;
  border-color: #09665c;
  padding: 4px 8px;
  color: white;
}
.btn-deceased:hover {
  background-color: #04332e;
  border-color: #04332e;
  color: white;
}
.deceased-mobile {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  max-width: 100%
}
.deceased-desktop {
  max-width: 50%;
}
.deceased-collapsed {
  max-width: 90px;
  background: transparent;
  position: absolute;
  right: 10px;
}
</style>
